import 'slick-carousel/slick/slick-theme.scss';
import './application.scss';

